import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { DashboardService } from '../../../services/dashboard.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-pending-leave',
  templateUrl: './pending-leave.component.html',
  styleUrls: ['./pending-leave.component.css'],
  providers: [DashboardService]
})
export class PendingLeaveComponent implements OnInit {

  urlLeaveRrquest: string;
  date: string;
  startDate: Date;
  endDate: Date;
  authUser: any = {};
  leaveList: Array<any> = [];
  title: string;
  countOfLeave: string = '0';

  private constants = Constants;

  constructor(
    private cookieManagerService: CookieManagerService,
    private DashboardService: DashboardService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    let $this = this;
    let date = new Date();
    this.getAuthUser();
    // get start date (privious month first date)
    this.startDate = new Date(date.getFullYear(),date.getMonth() - 1, 1);
    // get start date (next month last date)
    this.endDate = new Date(date.getFullYear(),date.getMonth() + 2, 0);
    // title
    this.title = this.datePipe.transform(this.startDate, this.constants.dateFormat)+' to '+this.datePipe.transform(this.endDate, this.constants.dateFormat);
    // create url for view pending leave
    this.urlLeaveRrquest = this.constants.mainUrl+''+this.constants.urlForLeaveRequest; 
    // check permission and get the pending leave request
    this.checkAdminUserPermission();
  }

  /**
   * kaushalya
   * get pending leave list
   * @param startDate 
   * @param endDate 
   * 2017-07-24
   */
  getPendingLeaveList(startDate , endDate) {
    this.DashboardService.getPendingLeave({ startDate ,endDate}).subscribe(
      res => {
        this.leaveList = Object.keys(res.data.leave).map((key) => { return res.data.leave[key] });
        this.countOfLeave = res.data.count;
      }
    );
  }

  /**
 * kaushalya
 * 2017-07-24
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
}

  /**
   * kaushalya
   * 2017-07-24
   * check user is adminUser or supervisor to give view permission for div
   */

  checkAdminUserPermission() {    
    if (this.authUser.user_role_id != WorkConstants.basicConstans.adminRoleId && this.authUser.user_role_id != WorkConstants.basicConstans.supervisorRoleId) {
      $('#pending-leave-requests').hide();
    } else {
      this.getPendingLeaveList(this.datePipe.transform(this.startDate, this.constants.dateFormat), this.datePipe.transform(this.endDate, this.constants.dateFormat));
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/pending-leave/pending-leave.component.ts